import React from 'react';
import PropTypes from 'prop-types';
import './FAQ.css';
import { Card, CardBody, CardHeader, CardText, CardTitle, Col } from "reactstrap";

const FAQ = () => (
        <>


                <div className='container mt-3'>
                        <div style={{ textAlign: 'justify' }}>

                                <Card >



                                        <h3 className='text-center' style={{ color: '#123fae', backgroundColor: '#a2a2a208' }} >FREQUENTLY ASKED QUESTIONS (FAQs)</h3>

                                        <CardBody >


                                                <b><CardText >
                                                        Question 1: What is the benefit of doing HS-CIT(A) and HS-CIT(A+)?
                                                </CardText></b>
                                                <CardText>Answer: HS-CIT(A) and HS-CIT(A+) holds an esteemed status in the government sector, as it has been granted exemption from the State Eligibility Test in Computer Appreciation and Application (SETC) Part I, rendering it a coveted qualification in the realm of computer literacy and application.
                                                </CardText>


                                                <b><CardText  >Question 2. I am interested in taking admission in online certificate courses, what should be my first step? </CardText></b>
                                                <CardText>Answer: We appreciate your interest in the online certificate courses run by CDOE, GJUS&T Hisar. The first step you should take is to visit our admission portal i.e. https://gjuskillcourses.hkcl.in/. Then fill in the online form and pay the requisite fee at this admission portal.
                                                </CardText>

                                                <b><CardText >Question 3. What are the benefits of doing these certificate courses?
                                                </CardText></b>
                                                <CardText>Answer: These certificate courses are aligned with National Skill Qualification Framework (NSQF) and these are job-oriented courses, which provide the students an opportunity to pursue their own work in future.
                                                </CardText>
                                                <b><CardText >Question 4. Is it Compulsory to apply online and what is mode of fee payment?
                                                </CardText></b>
                                                <CardText>Answer: Yes, all admission to these certificate courses is available through Online payment by Netbanking/ Credit/Debit card etc.
                                                </CardText>
                                                {/* <b><CardText >Question 4. How to contact the university's representative for more information?
</CardText></b>
        <CardText>Answer: There are multiple channels to help you for this:
Email Helpline: gjuskillcourses@hkcl.in
WhatsApp Helpline: 
Helpline No.: 
For more details, please visit our contact us page at www.gjuskillcourses.hkcl.in
</CardText> */}
                                                <b><CardText >Question 5.  Do I have to visit CDOE, GJUS&T for admission or any other purpose?</CardText></b>
                                                <CardText>Answer: Not necessarily. After completing the online admission form and pay the requisite fee, the learner code and password will be sent to you at your registered email id within 3-7 working days.
                                                        Also, you can give the internal as well as external exam from your own native place by following the instructions given by CDOE, GJU & HKCL. The certificate cum marksheet for the passing students will be sent by registered post to their address given in application form.
                                                </CardText>
                                                <b><CardText >Question 6. I am from a different University. Can I also apply for a course of my choice?
                                                </CardText></b>
                                                <CardText>Answer: Yes, you are welcome! You can do these certificate courses along with any regular/distance/private degree/diploma programs from GJU or any other University/College.
                                                </CardText>
                                                <b><CardText >Question 7. Can I enroll for Admission in two or more courses simultaneously?
                                                </CardText></b>
                                                <CardText>Answer: Yes, you may enroll in as many Certificate Courses as you like.
                                                </CardText>

                                                <b><CardText >Question 8. What is the medium of instruction of these certificate courses?
                                                </CardText></b>
                                                <CardText>Answer: The medium of instruction is English.</CardText>

                                                {/* <b>
                <CardText >
Question 9. Is there any contact number where I may call?
</CardText></b>
        <CardText>Answer: Yes, you can contact 0172- ............... on any working day from 09:00 AM to 05:00 PM.
</CardText> */}

                                                {/* <b><CardText >
Question 10. If I enter wrong information in my admission form, how can I get it corrected?
</CardText></b>
        <CardText>Answer: Feel relaxed. Request for correction by writing us at gjuskillcourses@hkcl.in  within 12 hours of submission of Application Form.
</CardText> */}
                                                <b><CardText >
                                                        Question 9: Do I have to submit any assignment?
                                                </CardText></b>
                                                <CardText>Answer: Yes, the assignment will be shared with the students through the LMS only.
                                                </CardText>




                                        </CardBody>
                                </Card>
                        </div>
                </div>
        </>
);

FAQ.propTypes = {};

FAQ.defaultProps = {};

export default FAQ;
